<script setup lang="ts">
const heading = 'Ergoline solárium';
const description =
  'Po náročném tréninku si u nás můžeš dát saunu, úžasnou masáž nebo navštívit solárium. Naše solárium Ergoline Inspiration 400 Super Power krásně opaluje a je navíc vybaveno trubicemi, které podporují tvorbu kolagenu. Kosmetické přípravky před i po opalování lze zakoupit přímo na recepci.';
</script>

<template>
  <div
    class="gap-r12 lg:gap-r18 text-client-black flex w-full flex-col lg:w-1/2"
  >
    <div class="gap-r6 flex flex-col">
      <AppHeading tag="h2">{{ heading }}</AppHeading>
      <AppParagraph>{{ description }}</AppParagraph>
    </div>
  </div>
</template>
